module.exports = "<app-sur-question-cat></app-sur-question-cat>"